module.exports = __webpack_public_path__ + "img/symbol_1.89fd08aa.png";